import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import ItemService from "../../../services/customer_appCommonService";
import { useDispatch, useSelector } from "react-redux"; //useDispatch
import { InputField } from "../../../Components/formElements/InputField";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import Constants from "../../../common/SupplierConstants";
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
import {
  // validateBankAccount,
  validateContactNumber,
  // validateEmail,
  validateName,
  validateRequired,
  validPostalCode,
} from "../../../common/Validations";
import Layout from "../../../Layout/Layout";
import FileViewerModal from "../../../Components/FileViewer/FileViewerModal";
import CommonFillter from "../../../Components/Filter/Supplier/SupplierCommonFillter";
import toast from "react-hot-toast";
import HRConstants from "../../../common/HRConstants";
import ItemServiceV2 from "../../../services/human_resource_appCommonService";
import DataTable from "react-data-table-component";
import { TableStatusField } from "../../../Components/formElements/TableStatusField";
import SalaryBreakupCalculator, {
  EMPTY_SALARY_OBJ,
} from "./Salarybreakupcalculator";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  VALID_BANK_ACC: "validate banck account number",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  GET_MAP_DISTANCE: "Please Click the Get Distance & Time button",
  DOC_NUMBER: "Invalid Document Number",
};

const EmployeeDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const historyGuardRef = useRef(false);
  const initialFormRef = useRef(null);
  localStorage.setItem("menu", "Employee");
  localStorage.setItem("submenu", "Employee Master");
  const appConfig = useSelector((state) => state?.app?.appConfig); // Application Details from Store
  let userData = useSelector((state) => state?.user?.data);
  let documentNumber = useSelector((state) => state?.hr?.employee?.employeeNr);
  let dropdownOption = [
    {
      id: "1",
      name: "Yes",
    },
    {
      id: "2",
      name: "No",
    },
  ];

  const employeeGender = [
    { id: 1, code: "1", name: "Male" },
    { id: 2, code: "2", name: "Female" },
  ];

  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  const designationData = [
    {
      id: 1,
      code: "D01",
      name: "Software Developer",
      description: "Software development and maintenance",
    },
    {
      id: 2,
      code: "D02",
      name: "Senior Software Developer",
      description: "Senior-level software development",
    },
    {
      id: 3,
      code: "D03",
      name: "Team Lead",
      description: "Team management and technical leadership",
    },
    {
      id: 4,
      code: "D04",
      name: "Project Manager",
      description: "Project planning and management",
    },
    {
      id: 5,
      code: "D05",
      name: "HR Manager",
      description: "Human resource management",
    },
    {
      id: 6,
      code: "D06",
      name: "Accountant",
      description: "Accounting and financial operations",
    },
    {
      id: 7,
      code: "D07",
      name: "Sales Executive",
      description: "Sales and customer management",
    },
    {
      id: 8,
      code: "D08",
      name: "Driver",
      description: "Vehicle driving and transportation",
    },
    {
      id: 9,
      code: "D09",
      name: "Office Assistant",
      description: "Office support and administrative work",
    },
    {
      id: 10,
      code: "D10",
      name: "Other",
      description: "Other designation",
    },
  ];

  const jobRoleData = [
    { id: 1, code: "1", name: "Driver" },
    { id: 2, code: "2", name: "Salesman" },
    { id: 3, code: "3", name: "Office Boy" },
    { id: 4, code: "4", name: "Others" },
  ];
  const getDepartment = [
    {
      id: 1,
      code: "DEP001",
      name: "Human Resources",
      description: "Human Resources",
    },
    {
      id: 2,
      code: "DEP002",
      name: "Information Technology",
      description: "Information Technology",
    },
    { id: 3, code: "DEP003", name: "Finance", description: "Finance" },
    { id: 4, code: "DEP004", name: "Sales", description: "Sales" },
    { id: 5, code: "DEP005", name: "Marketing", description: "Marketing" },
    { id: 6, code: "DEP006", name: "Operations", description: "Operations" },
    { id: 7, code: "DEP007", name: "Procurement", description: "Procurement" },
    { id: 8, code: "DEP008", name: "Production", description: "Production" },
    {
      id: 9,
      code: "DEP009",
      name: "Quality Assurance",
      description: "Quality Assurance",
    },
    {
      id: 10,
      code: "DEP010",
      name: "Research & Development",
      description: "Research & Development",
    },
    {
      id: 11,
      code: "DEP011",
      name: "Administration",
      description: "Administration",
    },
    {
      id: 12,
      code: "DEP012",
      name: "Customer Support",
      description: "Customer Support",
    },
    { id: 13, code: "DEP013", name: "Legal", description: "Legal" },
    { id: 14, code: "DEP014", name: "Logistics", description: "Logistics" },
    { id: 15, code: "DEP015", name: "Maintenance", description: "Maintenance" },
  ];
  const getReportingPerson = [
    { id: 1, code: "EMP001", name: "John Smith", description: "John Smith" },
    {
      id: 2,
      code: "EMP002",
      name: "Sarah Johnson",
      description: "Sarah Johnson",
    },
    {
      id: 3,
      code: "EMP003",
      name: "Michael Brown",
      description: "Michael Brown",
    },
    { id: 4, code: "EMP004", name: "Emily Davis", description: "Emily Davis" },
  ];

  const [getReportingContactPerson, setReportingContactPerson] = useState([
    {
      id: Date.now(),
      contactTitle: "",
      department: "",
      reportingPerson: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    },
  ]);
  const handleChangeReportingContact = (id, fieldName, value) => {
    const errors = {};

    if (!validateRequired(value)) {
      errors[fieldName] = `${fieldName} is required.`;
    }

    if (fieldName === "contactNumber" && validateRequired(value)) {
      if (!validateContactNumber(value)) {
        errors[fieldName] = "Invalid contact number. Must be 10 digits.";
      }
    }

    setReportingContactPerson((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc,
      ),
    );

    setValidation((prev) => ({
      ...prev,
      [`${id}_${fieldName}`]: errors[fieldName] || "",
    }));
  };
  // let requiredFields = [];
  const [isEditMode, setIsEditMode] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isDraftSaving, setIsDraftSaving] = useState(false);
  const [isCardVisible9, setCardVisible9] = useState(true);
  const [getFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  // eslint-disable-next-line
  const [getSalaryAmt, setSalaryAmt] = useState({});
  // eslint-disable-next-line
  const [getErrorFields, setErrorFields] = useState([]);
  const [showSalaryRevision, setShowSalaryRevision] = useState(false);
  const [selectedSalaryRevision, setSelectedSalaryRevision] = useState("");
  const salaryRevisionOptions = [
    { id: "V1", name: "V1" },
    { id: "V2", name: "V2" },
    { id: "V3", name: "V3" },
  ];
  const [getcontactPosition, setcontactPosition] = useState([]);
  const [getTitle, setTitle] = useState([]);
  const [getHrDoc, setHrDoc] = useState([]);
  const handleCancelClick = () => {
    if (hasFormChanges()) {
      // setShowDraftModal(true);
    } else {
      setIsEditMode(false);
      historyGuardRef.current = false;
    }
  };

  const [getcustomerContactPerson, setcustomerContactPerson] = useState([
    {
      id: Date.now(),
      contactPosition: "",
      contactTitle: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    },
  ]);
  const [getDocumentTypeData, setDocumentTypeData] = useState([
    {
      id: Date.now(),
      name: "Document 1",
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      certificateCode: "29AADCN1012B1Z6",
    },
  ]);

  const [getdocumentType, setdocumentType] = useState([]);
  const [showOtherRoleInput, setShowOtherRoleInput] = useState(false);

  const [getState, setState] = useState([]);
  const [getCountry, setCountry] = useState([]);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const [validation, setValidation] = useState({
    employeeName: "",
    routeNumber: "",
    commission: "Yes",
    commissionRate: "",
  });

  //bank state
  const [getBankDetails, setBankDetails] = useState([]);
  const [getBankDetailsData, setBankDetailsData] = useState([]);
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility9 = () => {
    setCardVisible9(!isCardVisible9);
  };
  const onInputChange = ({ target: { name, value } }) => {
    const errors = {};
    // setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    setFormInputs((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "employeeName" && {
        organisationName: value,
      }),
    }));
    validateName(name === "employeeName" ? value : "")
      ? (errors.employeeName = "")
      : (errors.employeeName = message.VALID_CUSTOMER_NAME);
    validPostalCode(name === "cityPostalCode" ? value : "")
      ? (errors.cityPostalCode = "")
      : (errors.cityPostalCode = message.VALID_POSTAL_CODE);

    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };

  const [formInputs, setFormInputs] = useState({
    createdBy: userData?.userId || "",
    employeeName: "",
    address: "",
    address2: "",
    city: "",
    country: "IN - India",
    state: "IN - Karnataka",
    cityPostalCode: "",
    companyCode: "",

    version: "v0",
    status: "Registered",
    category: "VENDOR",

    routeNumber: "",
    commission: "Yes",
    commissionRate: "",
    salesOfficerCode: "",
    salesOfficerName: "",

    plantAddress: appConfig?.customerPlantAddress,
    projectLocation: "",

    customerTypeCode: "C03",
    customerTypeDesc: "Domestic",

    jobRole: "",
    otherJobRole: "",
  });
  useEffect(() => {
    if (formInputs?.salaryAmt?.activeRevision) {
      setSelectedSalaryRevision(formInputs.salaryAmt.activeRevision);
      setShowSalaryRevision(true);
    }
  }, [formInputs?.salaryAmt?.activeRevision]);
  const currentSalaryAmt = useMemo(() => {
    if (!selectedSalaryRevision) {
      return formInputs?.salaryAmt ?? EMPTY_SALARY_OBJ;
    }
    const revisionKey = `reviseSalary${selectedSalaryRevision}`;
    return formInputs?.salaryAmt?.[revisionKey] ?? EMPTY_SALARY_OBJ;
  }, [formInputs?.salaryAmt, selectedSalaryRevision]);

  const handleSalaryChange = useCallback(
    (updatedSalary) => {
      if (!isEditMode || !selectedSalaryRevision) return;

      const revisionKey = `reviseSalary${selectedSalaryRevision}`;

      setFormInputs((prev) => ({
        ...prev,
        salaryAmt: {
          ...(prev.salaryAmt || {}),
          [revisionKey]: updatedSalary,
          activeRevision: selectedSalaryRevision,
        },
      }));
    },
    [isEditMode, selectedSalaryRevision],
  );
  const status = formInputs?.headerStatus?.toLowerCase();

  const formInputsRef = useRef(formInputs);
  const hasFormChanges = () => {
    return JSON.stringify(formInputsRef.current) !== initialFormRef.current;
  };
  // eslint-disable-next-line
  const [disabled, setDisabled] = useState(false);
  // console.log(">>formInputs", formInputs);
  useEffect(() => {
    // dispatch(getSupplierCategorySelection()); // getSupplierCategorySelection store
    getMasterData();
  }, [dispatch]);

  useEffect(() => {
    if (getDropdownData?.codeType === "country") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      getStateData(getDropdownData?.code);
    } else if (getDropdownData?.codeType === "companyCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      // getStateData(getDropdownData?.code);
    } else if (getDropdownData?.textCode === "salesOfficerCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (
      getDropdownData?.codeType === "jobtitle" &&
      getDropdownData?.index
    ) {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData.index
            ? {
                ...doc,
                [getDropdownData.textField]: getDropdownData.name,
                [getDropdownData.textCode]: getDropdownData.code,
                [getDropdownData.textDesc]: getDropdownData.description,
              }
            : doc,
        ),
      );
    } else if (
      getDropdownData?.codeType === "title" &&
      getDropdownData?.index
    ) {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData.index
            ? {
                ...doc,
                [getDropdownData.textField]: getDropdownData.name,
                [getDropdownData.textCode]: getDropdownData.code,
                [getDropdownData.textDesc]: getDropdownData.description,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.codeType === "documentType") {
      setDocumentTypeData((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,
              }
            : doc,
        ),
      );
    }

    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  useEffect(() => {
    if (getDropdownData?.textCode === "jobRoleCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));

      // Show input only if code is "4" (Others)
      if (getDropdownData?.code === "4") {
        setShowOtherRoleInput(true);
      } else {
        setShowOtherRoleInput(false);
        setFormInputs((prev) => ({
          ...prev,
          otherJobRole: "",
        }));
      }
    } else if (getDropdownData?.textCode === "employeeGenderCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    // Other conditions remain unchanged...

    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
  }, [getDropdownData]);
  const loadFirstLevelData1 = async (page) => {
    if (documentNumber !== "") {
      let obj = {
        documentNumber: documentNumber,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      await ItemService.getCustomerDetail(obj).then((item) => {
        // console.log(">> res!", item);
        if (item?.status === 200) {
          const loadedData = item?.data[0];
          setFormInputs(loadedData);
          setReportingContactPerson(loadedData?.reportingDetails || []);
          setcustomerContactPerson(loadedData?.contactDetails || []);
          setBankDetails(loadedData?.bandkDetails || []);
          setDocumentTypeData(loadedData?.certifications || []);
          setHrDoc(loadedData?.employeeDoc || []);
          setSalaryAmt(loadedData?.salaryAmt || []);

          // Derive the latest revision from salaryAmt keys
          const salaryAmtObj = loadedData?.salaryAmt || {};
          const revisionKeys = Object.keys(salaryAmtObj).filter((k) =>
            k.startsWith("reviseSalary"),
          );

          if (revisionKeys.length > 0) {
            // Sort by the numeric suffix (V1, V2, V10, etc.)
            const latestRevisionKey = revisionKeys.sort((a, b) => {
              const aNum = parseInt(a.replace("reviseSalaryV", ""), 10);
              const bNum = parseInt(b.replace("reviseSalaryV", ""), 10);
              return bNum - aNum; // descending
            })[0];

            const latestRevision = latestRevisionKey.replace(
              "reviseSalary",
              "",
            ); // "V1", "V2", etc.
            setSelectedSalaryRevision(latestRevision);
            setShowSalaryRevision(true);
          } else {
            // No revisions yet — clear selection and show base salary
            setSelectedSalaryRevision("");
            setShowSalaryRevision(false);
          }

          // Optional: if you want to persist activeRevision in the object itself
          // setFormInputs((prev) => ({
          //   ...prev,
          //   salaryAmt: {
          //     ...prev.salaryAmt,
          //     activeRevision: revisionKeys.length > 0 ? latestRevision : undefined,
          //   },
          // }));
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });
      // setLoading(false);
    }
  };
  useEffect(() => {
    loadFirstLevelData1();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Load Master Data
  const getMasterData = async () => {
    let obj = {
      codeType: "title",
    };
    await ItemService.getMasterDataSelf(obj).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        setTitle(item?.data);
      } else {
        setTitle([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj1 = {
      codeType: "documentType",
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setdocumentType(item?.data);
      } else {
        setdocumentType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj2 = {
      codeType: "jobtitle",
    };
    await ItemService.getMasterDataSelf(obj2).then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        setcontactPosition(item?.data);
      } else {
        setcontactPosition([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj3 = {
      codeType: "country",
    };
    await ItemService.getMasterDataSelf(obj3).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setCountry(item?.data);
      } else {
        setCountry([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };
  // Onselect of Country state will load
  const getStateData = async (code) => {
    let obj1 = {
      codeType: "region",
      code: code,
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setState(item?.data);
      } else {
        setState([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  // eslint-disable-next-line no-unused-vars
  const navigateToLogin = () => {
    navigate(Constants.LOGIN);
  };

  // eslint-disable-next-line
  const addCustomerCantactPerson = () => {
    const newDocument = {
      id: Date.now(),
      contactPosition: "",
      contactTitle: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    };
    setcustomerContactPerson((prevData) => [...prevData, newDocument]);
  };

  const handleChangeCustomerContacts = (id, fieldName, value) => {
    const errors = {};

    // Required field validation
    if (!validateRequired(value)) {
      errors[fieldName] = `${fieldName} is required.`;
    }

    // Contact number format validation
    if (fieldName === "contactNumber" && validateRequired(value)) {
      if (!validateContactNumber(value)) {
        errors[fieldName] = "Invalid contact number. Must be 10 digits.";
      }
    }
    setcustomerContactPerson((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc,
      ),
    );
    // Update validation state
    setValidation((prev) => ({
      ...prev,
      [`${id}_${fieldName}`]: errors[fieldName] || "",
    }));
  };
  // eslint-disable-next-line
  const addDocumentType = () => {
    const newDocument = {
      id: Date.now(),
      name: `Document ${getDocumentTypeData.length + 1}`,
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      certificateCode: "",
    };
    setDocumentTypeData((prevData) => [...prevData, newDocument]);
  };
  const handleInputChange = (id, fieldName, value) => {
    const errors = {};

    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc,
      ),
    );

    setValidation((prev) => ({
      ...prev,
      [`${id}_${fieldName}`]: errors[fieldName] || "",
    }));
  };
  // View attachment files
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  const bankInfoInitialData = {
    id: "",
    bankNotListed: "",
    bankAccountNumber: "",
    bankKey: "",
    bankName: "",
    bankCountry: "",
    bankAddress: "",
    AccountHolderName: "",
    bankCompanyletterhead: "",
    bankConfirmationLetter: "",
    chipsCode: "",
    swiftIfscCode: "",
    bankInfoTemplate: "",
    preferredCurrency: "",
  };

  //Load Bank Master Data
  const getBankMasterData = async () => {
    await ItemService.getBankMasterData().then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        setBankDetailsData(item?.data);
      } else {
        setBankDetailsData([]);
        console.log(">> Error: Loading getBankMasterData");
      }
    });
  };
  useEffect(() => {
    getBankMasterData(); // Load Bank Details
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addBankForm = () => {
    const uniqueId = Date.now().toString(); // or use uuid if you prefer
    const newForm = { ...bankInfoInitialData, id: uniqueId };
    setBankDetails([...getBankDetails, newForm]);
  };

  const removeBankForm = (indexToRemove) => {
    setBankDetails(
      getBankDetails.filter((form, index) => index !== indexToRemove),
    );
  };

  useEffect(() => {
    setBankDetails([...getBankDetails, bankInfoInitialData]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeBankInfo = (id, key, value) => {
    const updatedBankDetails = getBankDetails.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          [key]: value,
          ...(key === "bankKey" &&
            (() => {
              const selectedBank = getBankDetailsData.find(
                (bank) => bank.name === value,
              );
              return selectedBank
                ? {
                    bankCountryDescription: selectedBank.bankCountryDescription,
                    bankAccountName: selectedBank.bankAccountName,
                    bankAddress: selectedBank.bankAddress,
                    bankBranchName: selectedBank.bankBranchName,
                    bankCurrency: selectedBank.bankCurrency,
                  }
                : {};
            })()),
        };
      }
      return item;
    });

    setBankDetails(updatedBankDetails);

    // Validate
    const errorMsg = !value ? `${key} is required.` : "";

    setValidation((prev) => ({
      ...prev,
      [`${id}_${key}`]: errorMsg,
    }));
  };
  const handleUpdateClick = () => {
    setIsEditMode(true);
  };
  const handleConvertToEmp = async () => {
    let obj = {
      data: formInputs,
      contactDetails: getcustomerContactPerson,
      certifications: getDocumentTypeData,
      type: "Save",
    };
    await ItemServiceV2.addEmployee(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "added successfully", {
          duration: 8000,
          position: "top-right",
        });
        navigate(HRConstants.HR_EMP_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      // setDisabled(false);
    });
  };

  const handleSaveClick = async () => {
    if (isDraftSaving) return;

    setIsDraftSaving(true);
    const toastId = toast.loading("Saving...", {
      position: "top-right",
    });

    try {
      const payload = {
        ...formInputs,
        contactDetails: getcustomerContactPerson,
        certifications: getDocumentTypeData,
      };

      const response = await ItemServiceV2.updateEmployee(payload);
      if (response?.status === 200) {
        toast.dismiss(toastId);
        toast.success("Employee updated successfully", {
          position: "top-right",
        });

        setIsEditMode(false);
        loadFirstLevelData1();
        navigate(HRConstants.HR_EMP_LIST);
      } else {
        toast.dismiss(toastId);
        toast.error(response?.message || "Failed to update employee", {
          position: "top-right",
        });
      }
    } catch (error) {
      console.error(error);

      toast.dismiss(toastId);
      toast.error("Something went wrong. Please try again.", {
        position: "top-right",
      });
      throw error;
    } finally {
      setIsDraftSaving(false);
    }
  };

  const hrDataColumns = [
    {
      name: (
        <>
          <i className="bi bi-file-earmark-text labelIcon"></i>
          Document Number
        </>
      ),
      selector: (row) => row.hrDocNr || "--",
      cell: (row) => (
        <button
          className="btnInfo"
          // onClick={() => detailedPageHRDocument(row.hrDocNr)}
        >
          {row.hrDocNr || "--"}
        </button>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: (
        <>
          <i className="bi bi-tag labelIcon"></i>
          Document Type
        </>
      ),
      selector: (row) => row.hrDocTypeDesc || "--",
      sortable: true,
      width: "170px",
    },
    {
      name: (
        <>
          <i className="bi bi-check-circle labelIcon"></i>
          Status
        </>
      ),
      selector: (row) => row.headerStatus || "--",
      cell: (row) => <TableStatusField status={row.headerStatus} />,
      sortable: true,
      width: "160px",
    },

    {
      name: (
        <>
          <i className="bi bi-person-badge labelIcon"></i>
          Created By
        </>
      ),
      selector: (row) => row.createdBy || "--",
      sortable: true,
      width: "150px",
    },

    {
      name: (
        <>
          <i className="bi bi-calendar-plus labelIcon"></i>
          Created At
        </>
      ),
      selector: (row) => row.createdAt || "--",
      cell: (row) => (
        <span>
          {row.createdAt ? new Date(row.createdAt).toLocaleDateString() : "--"}
        </span>
      ),
      sortable: true,
      width: "150px",
    },
  ];
  return (
    <main className="dashboard main sri-venkateshwara" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Employee Details{" "}
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {documentNumber}
              </span>
              {/* <span>
                {formInputs?.statusHeader === "New" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {formInputs?.statusHeader}
                  </span>
                ) : formInputs?.statusHeader === "Created" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {formInputs?.statusHeader}
                  </span>
                ) : formInputs?.statusHeader === "Deleted" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {formInputs?.statusHeader}
                  </span>
                ) : formInputs?.statusHeader === "Cancelled" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {formInputs?.statusHeader}
                  </span>
                ) : (
                  formInputs?.statusHeader
                )}
              </span> */}
              {/* <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {formInputs?.revisionLabel}
              </span> */}
            </h2>

            <Row className="mb-2">
              <Row className="mb-2">
                <Col xs={12} className="d-flex justify-content-end gap-2">
                  {!isEditMode ? (
                    <button
                      className="btnTable btn-update"
                      onClick={handleUpdateClick}
                      disabled={["deleted", "cancelled"].includes(status)}
                    >
                      <i className="bi bi-pencil-square"></i> Modify
                    </button>
                  ) : (
                    <>
                      <button
                        className="btnTable btn-update"
                        onClick={
                          status === "draft"
                            ? handleConvertToEmp
                            : handleSaveClick
                        }
                      >
                        <i
                          className={`bi ${status === "draft" ? "bi-arrow-repeat" : "bi-save"}`}
                        ></i>
                        {status === "draft" ? " Convert to Employee" : " Save"}
                      </button>

                      <button
                        className="btn btn-secondary btn-update"
                        onClick={handleCancelClick}
                      >
                        <i className="bi bi-x-circle"></i> Cancel
                      </button>
                    </>
                  )}
                </Col>
              </Row>
            </Row>
            <hr />
            {/* customer details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">E</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Employee </span>
                      <span className="subHeaderTitle">Employee Details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          // label="Position/Job Role"
                          label={
                            <>
                              <i className="bi bi-briefcase labelIcon"></i>
                              Position/Job Role
                            </>
                          }
                          name="jobRole"
                          code="jobRoleCode"
                          description="jobRoleDesc"
                          data={jobRoleData}
                          id="jobRole"
                          iconClassName="dropdownIcon"
                          setValue={formInputs?.jobRole}
                          error={validation.jobRole}
                          getvalue={setDropdownData} // This should update getDropdownData
                          required={true}
                          // disabled={true}
                          disabled={!isEditMode}
                        />
                      </Col>
                      {showOtherRoleInput && (
                        <>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Role"
                              name="otherJobRole"
                              placeholder=""
                              value={formInputs.otherJobRole || ""}
                              onChange={onInputChange}
                              error={validation.otherJobRole}
                              // disabled={true}
                              disabled={!isEditMode}
                            />
                          </Col>
                        </>
                      )}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label={
                            <>
                              <i className="bi bi-person-badge labelIcon"></i>
                              Department
                            </>
                          }
                          name="department"
                          code="departmentCode"
                          description="departmentDesc"
                          data={getDepartment}
                          id="department"
                          iconClassName="dropdownIcon"
                          setValue={formInputs?.department}
                          error={validation.department}
                          getvalue={setDropdownData}
                          required={true}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label={
                            <>
                              <i className="bi bi-person-badge labelIcon"></i>
                              Designation
                            </>
                          }
                          name="designation"
                          code="designationCode"
                          description="designationDesc"
                          data={designationData}
                          id="designation"
                          iconClassName="dropdownIcon"
                          setValue={formInputs?.designation}
                          error={validation.designation}
                          getvalue={setDropdownData}
                          required={true}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <label className="form-label">
                          <i className="bi bi-arrow-repeat labelIcon"></i>
                          Salary Revision
                        </label>

                        {!showSalaryRevision ? (
                          <button
                            type="button"
                            className="btnTable btn-update w-100"
                            onClick={() => setShowSalaryRevision(true)}
                            disabled={!isEditMode}
                          >
                            <i className="bi bi-arrow-repeat"></i>
                            Revision
                          </button>
                        ) : (
                          <select
                            className="form-select"
                            value={selectedSalaryRevision}
                            onChange={(e) =>
                              setSelectedSalaryRevision(e.target.value)
                            }
                            disabled={!isEditMode}
                          >
                            <option value="">Select Version</option>

                            {salaryRevisionOptions.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        )}
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Employee Name"
                          label={
                            <>
                              <i className="bi bi-person labelIcon"></i>
                              Employee Name
                            </>
                          }
                          name="employeeName"
                          placeholder=""
                          value={formInputs.employeeName || ""}
                          onChange={onInputChange}
                          required={true}
                          error={validation.employeeName}
                          // disabled={true}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Mobile Nr"
                          label={
                            <>
                              <i className="bi bi-telephone labelIcon"></i>
                              Mobile Nr
                            </>
                          }
                          name="mobileNr"
                          placeholder=""
                          value={formInputs.mobileNr || ""}
                          onChange={onInputChange}
                          error={validation.mobileNr}
                          // disabled={true}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Mobile Nr"
                          label={
                            <>
                              <i className="bi bi-envelope labelIcon"></i>
                              Email ID
                            </>
                          }
                          name="empEmailId"
                          placeholder=""
                          value={formInputs.empEmailId || ""}
                          onChange={onInputChange}
                          error={validation.empEmailId}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          // label="Gender"
                          label={
                            <>
                              <i className="bi bi-gender-ambiguous labelIcon"></i>
                              Gender
                            </>
                          }
                          name="employeeGender"
                          code="employeeGenderCode"
                          description="employeeGenderDesc"
                          data={employeeGender}
                          id="employeeGender"
                          iconClassName="dropdownIcon"
                          setValue={formInputs?.employeeGender}
                          error={validation.employeeGender}
                          getvalue={setDropdownData} // This should update getDropdownData
                          required={true}
                          // disabled={true}
                          disabled={!isEditMode}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label=" Address Lines 1 / Street"
                          label={
                            <>
                              <i className="bi bi-geo-alt labelIcon"></i>
                              Address Lines 1 / Street
                            </>
                          }
                          name="address"
                          placeholder=""
                          value={formInputs.address || ""}
                          onChange={onInputChange}
                          error={validation.address}
                          required={true}
                          // disabled={true}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Address Line 2"
                          label={
                            <>
                              <i className="bi bi-signpost-2 labelIcon"></i>
                              Address Line 2
                            </>
                          }
                          name="address2"
                          placeholder=""
                          value={formInputs.address2 || ""}
                          onChange={onInputChange}
                          error={validation.address2}
                          required={true}
                          // disabled={true}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="City"
                          label={
                            <>
                              <i className="bi bi-buildings labelIcon"></i>
                              City
                            </>
                          }
                          name="city"
                          placeholder=""
                          value={formInputs.city || ""}
                          onChange={onInputChange}
                          error={validation.city}
                          required={true}
                          // disabled={true}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          // label="Country"
                          label={
                            <>
                              <i className="bi bi-globe-asia-australia labelIcon"></i>
                              Country
                            </>
                          }
                          placeholder=""
                          data={getCountry}
                          id="country"
                          iconClassName="dropdownIcon"
                          name="country"
                          code="countryCode"
                          description="countryDesc"
                          setValue={formInputs.country}
                          getvalue={setDropdownData}
                          required={true}
                          // disabled={true}
                          disabled={!isEditMode}
                          // error={validation.country}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          // label="State"
                          label={
                            <>
                              <i className="bi bi-map labelIcon"></i>
                              State
                            </>
                          }
                          placeholder=""
                          data={getState}
                          id="state"
                          iconClassName="dropdownIcon"
                          name="state"
                          code="stateCode"
                          description="stateDesc"
                          setValue={formInputs.state}
                          getvalue={setDropdownData}
                          required={true}
                          // disabled={true}
                          disabled={!isEditMode}
                          // error={validation.state}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Postal Code/PO Box"
                          label={
                            <>
                              <i className="bi bi-mailbox labelIcon"></i>
                              Postal Code / PO Box
                            </>
                          }
                          name="cityPostalCode"
                          placeholder=""
                          value={formInputs.cityPostalCode}
                          onChange={onInputChange}
                          error={validation.cityPostalCode}
                          required={true}
                          // disabled={true}
                          disabled={!isEditMode}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*Customer Contact Person / Line Item */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CP</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Contact Person</span>
                      <span className="subHeaderTitle">
                        Customer Contact Person
                      </span>
                    </Col>
                    {/* <Col xs={4} md={2} lg={2}>
                      <div className="d-flex justify-content-end  p-2 me-3">
                        <button
                          className="btnTable"
                          onClick={addCustomerCantactPerson}
                        >
                          <i className="bi bi-plus-lg"></i> Add
                        </button>
                      </div>
                    </Col> */}
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex">
                                      <Col xs={12} md={2} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          <i className="bi bi-briefcase labelIcon"></i>
                                          Job Title
                                        </p>
                                      </Col>

                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          <i className="bi bi-person-badge labelIcon"></i>
                                          Contact Title
                                        </p>
                                      </Col>

                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          <i className="bi bi-person labelIcon"></i>
                                          Contact Person
                                        </p>
                                      </Col>

                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          <i className="bi bi-telephone labelIcon"></i>
                                          Contact Number
                                        </p>
                                      </Col>

                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          <i className="bi bi-envelope labelIcon"></i>
                                          Email-ID
                                        </p>
                                      </Col>

                                      {/* <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex">
                                          <i className="bi bi-gear labelIcon"></i>
                                          Action
                                        </p>
                                      </Col> */}
                                    </Row>
                                    {getcustomerContactPerson.map(
                                      (doc, index) => (
                                        <Row key={doc.id}>
                                          <Col xs={12}>
                                            <hr className="mx-4 my-0 text-color-black" />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <ComboboxField
                                              label=""
                                              placeholder="Job Title"
                                              data={getcontactPosition}
                                              id="contactPosition"
                                              codeType="jobtitle"
                                              iconClassName="dropdownIcon"
                                              name="contactPosition"
                                              code="contactPositionCode"
                                              description="contactPositionDesc"
                                              // setValue={doc?.contactPosition}
                                                setValue={doc?.contactPosition || doc?.contactPositionDesc}
                                              getvalue={setDropdownData}
                                              index={doc.id}
                                              onChangeValue={
                                                handleChangeCustomerContacts
                                              }
                                              // disabled={true}
                                              disabled={!isEditMode}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <ComboboxField
                                              label=""
                                              placeholder="Contact Title"
                                              data={getTitle}
                                              id="contactTitle"
                                              codeType="title"
                                              iconClassName="dropdownIcon"
                                              name="contactTitle"
                                              code="contactTitleCode"
                                              description="contactTitleDesc"
                                              // setValue={doc?.contactTitle}
                                                setValue={doc?.contactTitle || doc?.contactTitleDesc}
                                              getvalue={setDropdownData}
                                              index={doc.id}
                                              onChangeValue={
                                                handleChangeCustomerContacts
                                              }
                                              // disabled={true}
                                              disabled={!isEditMode}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="contactName"
                                              placeholder="Contact Person"
                                              value={doc.contactName || ""}
                                              onChange={(e) =>
                                                handleChangeCustomerContacts(
                                                  doc.id,
                                                  "contactName",
                                                  e.target.value,
                                                )
                                              }
                                              error={
                                                validation[
                                                  `${doc.id}_contactName`
                                                ]
                                              }
                                              // disabled={true}
                                              disabled={!isEditMode}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="contactNumber"
                                              placeholder="Contact Number"
                                              value={doc.contactNumber || ""}
                                              onChange={(e) =>
                                                handleChangeCustomerContacts(
                                                  doc.id,
                                                  "contactNumber",
                                                  e.target.value,
                                                )
                                              }
                                              error={
                                                validation[
                                                  `${doc.id}_contactNumber`
                                                ]
                                              }
                                              // disabled={true}
                                              disabled={!isEditMode}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              // label="Please Enter the Remarks*"
                                              name="contactEmail"
                                              placeholder="Email"
                                              value={doc.contactEmail || ""}
                                              onChange={(e) =>
                                                handleChangeCustomerContacts(
                                                  doc.id,
                                                  "contactEmail",
                                                  e.target.value,
                                                )
                                              }
                                              error={
                                                validation[
                                                  `${doc.id}_contactEmail`
                                                ]
                                              }
                                              // disabled={true}
                                              disabled={!isEditMode}
                                            />
                                          </Col>

                                          {/* <Col
                                            xs={12}
                                            md={4}
                                            lg={1}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <i
                                              onClick={() =>
                                                deleteCustomerContactPerosn(
                                                  doc.id,
                                                )
                                              }
                                              className="bi bi-trash text-danger fs-4"
                                            />
                                          </Col> */}
                                        </Row>
                                      ),
                                    )}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*Reporting person*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RP</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle">Reporting Details</span>
                      <span className="subHeaderTitle">Reporting Details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-4 d-none d-lg-flex">
                      <Col xs={12} md={2} lg={2}>
                        <p className="fs-6 fw-medium d-flex ms-4">
                          <i className="bi bi-person-badge labelIcon"></i>
                          Contact Title
                        </p>
                      </Col>

                      <Col xs={12} md={2} lg={2}>
                        <p className="fs-6 fw-medium d-flex ms-4">
                          <i className="bi bi-building labelIcon"></i>
                          Department
                        </p>
                      </Col>

                      <Col xs={12} md={2} lg={2}>
                        <p className="fs-6 fw-medium d-flex ms-4">
                          <i className="bi bi-person-check labelIcon"></i>
                          Reporting Person
                        </p>
                      </Col>

                      <Col xs={12} md={2} lg={2}>
                        <p className="fs-6 fw-medium d-flex ms-4">
                          <i className="bi bi-person labelIcon"></i>
                          Contact Person
                        </p>
                      </Col>

                      <Col xs={12} md={2} lg={2}>
                        <p className="fs-6 fw-medium d-flex ms-4">
                          <i className="bi bi-telephone labelIcon"></i>
                          Contact Number
                        </p>
                      </Col>

                      <Col xs={12} md={1} lg={1}>
                        <p className="fs-6 fw-medium d-flex ms-4">
                          <i className="bi bi-envelope labelIcon"></i>
                          Email-ID
                        </p>
                      </Col>

                      {/* 
                          <Col xs={12} md={1} lg={1}>
                            <p className="fs-6 fw-medium d-flex">
                              <i className="bi bi-gear labelIcon"></i>
                              Action
                            </p>
                          </Col> 
                          */}
                    </Row>
                    {getReportingContactPerson.map((doc, index) => (
                      <Row key={doc.id}>
                        <Col xs={12}>
                          <hr className="mx-4 my-0 text-color-black" />
                        </Col>
                        <Col
                          xs={12}
                          md={2}
                          lg={2}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label=""
                            placeholder="Contact Title"
                            data={getTitle}
                            id="contactTitle"
                            iconClassName="dropdownIcon"
                            name="contactTitle"
                            code="contactTitleCode"
                            description="contactTitleDesc"
                            setValue={doc?.contactTitle}
                            getvalue={setDropdownData}
                            index={doc.id}
                            onChangeValue={handleChangeReportingContact}
                            disabled={!isEditMode}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={2}
                          lg={2}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label=""
                            placeholder="Department"
                            data={getDepartment}
                            id="department"
                            iconClassName="dropdownIcon"
                            name="department"
                            code="departmentCode"
                            description="departmentDesc"
                            setValue={doc?.department}
                            getvalue={setDropdownData}
                            index={doc.id}
                            onChangeValue={handleChangeReportingContact}
                            disabled={!isEditMode}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={2}
                          lg={2}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label=""
                            placeholder="Reporting Person"
                            data={getReportingPerson}
                            id="reportingPerson"
                            iconClassName="dropdownIcon"
                            name="reportingPerson"
                            code="reportingPersonCode"
                            description="reportingPersonDesc"
                            setValue={doc?.reportingPerson}
                            getvalue={setDropdownData}
                            index={doc.id}
                            onChangeValue={handleChangeReportingContact}
                            disabled={!isEditMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={2}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox mt-1"
                            name="contactName"
                            placeholder="Contact Person"
                            value={doc.contactName || ""}
                            onChange={(e) =>
                              handleChangeReportingContact(
                                doc.id,
                                "contactName",
                                e.target.value,
                              )
                            }
                            error={validation[`${doc.id}_contactName`]}
                            disabled={!isEditMode}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={2}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox mt-1"
                            name="contactNumber"
                            placeholder="Contact Number"
                            value={doc.contactNumber || ""}
                            onChange={(e) =>
                              handleChangeReportingContact(
                                doc.id,
                                "contactNumber",
                                e.target.value,
                              )
                            }
                            error={validation[`${doc.id}_contactNumber`]}
                            disabled={!isEditMode}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={2}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox mt-1"
                            name="contactEmail"
                            placeholder="Email"
                            value={doc.contactEmail || ""}
                            onChange={(e) =>
                              handleChangeReportingContact(
                                doc.id,
                                "contactEmail",
                                e.target.value,
                              )
                            }
                            error={validation[`${doc.id}_contactEmail`]}
                            disabled={!isEditMode}
                          />
                        </Col>
                        {/* 
                                                <Col
                                                  xs={12}
                                                  md={4}
                                                  lg={1}
                                                  className="commTopButtonRightLeftPadding"
                                                >
                                                  <i
                                                    onClick={() => deleteReportingContactPerson(doc.id)}
                                                    className="bi bi-trash text-danger fs-4"
                                                  />
                                                </Col> */}
                      </Row>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            {/* customer Doucment Type */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DT</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Doucment Type</span>
                      <span className="subHeaderTitle">Doucment Type</span>
                    </Col>
                    {/* <Col xs={4} md={2} lg={2}>
                      <div className="d-flex justify-content-end  p-2 me-3">
                        <button className="btnTable" onClick={addDocumentType}>
                          <i className="bi bi-plus-lg"></i> Add
                        </button>
                      </div>
                    </Col> */}
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex">
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          <i className="bi bi-file-earmark-text labelIcon"></i>
                                          Document Type
                                        </p>
                                      </Col>

                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          <i className="bi bi-upc-scan labelIcon"></i>
                                          Document Number
                                        </p>
                                      </Col>

                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          <i className="bi bi-calendar-check labelIcon"></i>
                                          Issue Date
                                        </p>
                                      </Col>

                                      <Col xs={12} md={4} lg={1}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          <i className="bi bi-eye labelIcon"></i>
                                          View Files
                                        </p>
                                      </Col>

                                      {/* <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          <i className="bi bi-paperclip labelIcon"></i>
                                          Attachments
                                        </p>
                                      </Col> */}

                                      {/* <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex justify-content-center ms-4">
                                          <i className="bi bi-gear labelIcon"></i>
                                          Action
                                        </p>
                                      </Col> */}
                                    </Row>
                                    {getDocumentTypeData.map((doc, index) => (
                                      <Row key={doc.id}>
                                        <Col xs={12}>
                                          <hr className="mx-4 my-0 text-color-black" />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <ComboboxField
                                            label=""
                                            placeholder="Document type"
                                            data={getdocumentType}
                                            id="documentType"
                                            iconClassName="dropdownIcon"
                                            name="documentType"
                                            code="documentTypeCode"
                                            description="documentTypeDesc"
                                            setValue={doc?.documentType}
                                            getvalue={setDropdownData}
                                            index={doc.id}
                                            onChangeValue={handleInputChange}
                                            // disabled={true}
                                            disabled={!isEditMode}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            placeholder="Document Number"
                                            value={doc.documentNumber}
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "documentNumber",
                                                e.target.value,
                                              )
                                            }
                                            error={
                                              validation[
                                                `${doc.id}_documentNumber`
                                              ]
                                            }
                                            // disabled={true}
                                            disabled={!isEditMode}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            type="date"
                                            value={doc.issueDate}
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "issueDate",
                                                e.target.value,
                                              )
                                            }
                                            // disabled={true}
                                            disabled={!isEditMode}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <div className="d-flex justify-content-center">
                                            {(doc.iSOCertification && (
                                              <img
                                                src="assets/img/newIcons/attached-file.png"
                                                className="mt-1 attachmentIcon"
                                                alt="attachments"
                                                onClick={() =>
                                                  handleViewFile(
                                                    doc.iSOCertification,
                                                  )
                                                }
                                              />
                                            )) ||
                                              "--"}
                                          </div>
                                        </Col>
                                        {/* <Col
                                          xs={12}
                                          md={4}
                                          lg={3}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <FileUploadComponent
                                            id={doc.id}
                                            name="iSOCertification"
                                            label=""
                                            allowedTypes={[
                                              "image/png",
                                              "image/jpeg",
                                              "application/pdf",
                                            ]}
                                            multiple={true} // Change to `false` for single file selection
                                            required={true}
                                            onSuccessUpload={
                                              onSuccessUploadDocumentType
                                            }
                                            value={doc.iSOCertification || ""}
                                          />
                                        </Col> */}
                                        {/* <Col
                                          xs={12}
                                          md={4}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <i
                                            onClick={() =>
                                              deleteDocumentType(doc.id)
                                            }
                                            className="bi bi-trash text-danger fs-4"
                                          />
                                        </Col> */}
                                      </Row>
                                    ))}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* 08 Banker Info*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible8
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility8}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">BI</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Bank Information</span>
                      <span className="subHeaderTitle">
                        Bank Information (Please add all your Bank Accounts)
                      </span>
                    </Col>
                    <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => addBankForm()}
                        // disabled={getDisabledStatus}
                      >
                        <i className="bi bi-plus-lg"></i> Add Bank Info
                      </button>
                    </Col>

                    <Col xs={2} md={1} lg={1} className="">
                      <CommonFillter />
                    </Col>
                  </Row>
                </h2>

                {/* Banker Information */}
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible8 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    {/* To Load Dynamic Bank Info Form */}
                    {getBankDetails &&
                      getBankDetails?.map((item, index) => (
                        <div key={item.id}>
                          <Row className="pt-2 pb-2">
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="commTopButtonRightLeftPadding"
                            >
                              <h6>Bank Information Section {index + 1}</h6>
                              <span
                                className="deleteIconAccordion"
                                onClick={() => removeBankForm(index)}
                              >
                                {" "}
                                <i className="bi bi-x-circle"></i>{" "}
                              </span>
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                // label="Is the Company bank included on list?"
                                label={
                                  <>
                                    <i className="bi bi-patch-check labelIcon"></i>
                                    Is the Company bank included on list?
                                  </>
                                }
                                placeholder=""
                                data={dropdownOption}
                                id="bankNotListed"
                                iconClassName="dropdownIcon"
                                name="bankNotListed"
                                setValue={item?.bankNotListed || ""}
                                getvalue={setDropdownData}
                                index={item.id}
                                onChangeValue={handleChangeBankInfo}
                                // disabled={getDisabledStatus}
                                // disabled={true}
                                disabled={!isEditMode}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                // label="BankID"
                                label={
                                  <>
                                    <i className="bi bi-bank labelIcon"></i>
                                    BankID
                                  </>
                                }
                                placeholder=""
                                data={getBankDetailsData}
                                id="bankKey"
                                iconClassName="dropdownIcon"
                                name="bankKey"
                                setValue={item?.bankKey}
                                getvalue={setDropdownData}
                                index={item.id}
                                onChangeValue={handleChangeBankInfo}
                                error={
                                  item.bankNotListed === "Yes"
                                    ? validation[`${item.id}_bankKey`]
                                    : ""
                                }
                                disabled={!isEditMode}

                                // disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                // label="Bank A/C Number"
                                label={
                                  <>
                                    <i className="bi bi-credit-card-2-front labelIcon"></i>
                                    Bank A/C Number
                                  </>
                                }
                                name="bankAccountNumber"
                                placeholder=""
                                value={item?.bankAccountNumber}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankAccountNumber",
                                    e.target.value,
                                  )
                                }
                                error={
                                  item.bankNotListed === "Yes"
                                    ? validation[`${item.id}_bankAccountNumber`]
                                    : ""
                                }
                                disabled={!isEditMode}
                                // disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                // label="Bank Name"
                                label={
                                  <>
                                    <i className="bi bi-building labelIcon"></i>
                                    Bank Name
                                  </>
                                }
                                name="bankBranchName"
                                placeholder=""
                                value={item?.bankBranchName}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankBranchName",
                                    e.target.value,
                                  )
                                }
                                disabled={!isEditMode}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                // label="Bank Country"
                                label={
                                  <>
                                    <i className="bi bi-globe-asia-australia labelIcon"></i>
                                    Bank Country
                                  </>
                                }
                                name="bankCountryDescription"
                                placeholder=""
                                value={item?.bankCountryDescription}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankCountryDescription",
                                    e.target.value,
                                  )
                                }
                                disabled={!isEditMode}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                // label="Branch Address"
                                label={
                                  <>
                                    <i className="bi bi-geo-alt labelIcon"></i>
                                    Branch Address
                                  </>
                                }
                                name="bankAddress"
                                placeholder=""
                                value={item?.bankAddress}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankAddress",
                                    e.target.value,
                                  )
                                }
                                disabled={!isEditMode}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                // label="Preferred Currency"
                                label={
                                  <>
                                    <i className="bi bi-currency-rupee labelIcon"></i>
                                    Preferred Currency
                                  </>
                                }
                                name="bankCurrency"
                                placeholder=""
                                value={item?.bankCurrency}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankCurrency",
                                    e.target.value,
                                  )
                                }
                                disabled={!isEditMode}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                // label="Name of Beneficiary"
                                label={
                                  <>
                                    <i className="bi bi-person-vcard labelIcon"></i>
                                    Name of Beneficiary
                                  </>
                                }
                                extraLabel="Name of Beneficiary (Bank Account Holder Name) as per company /trade license"
                                name="AccountHolderName"
                                placeholder=""
                                value={item?.AccountHolderName}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "AccountHolderName",
                                    e.target.value,
                                  )
                                }
                                error={
                                  item.bankNotListed === "Yes"
                                    ? validation[`${item.id}_AccountHolderName`]
                                    : ""
                                }

                                // disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                // label="Swift IFSC Code"
                                label={
                                  <>
                                    <i className="bi bi-upc-scan labelIcon"></i>
                                    Swift IFSC Code
                                  </>
                                }
                                placeholder=""
                                data={dropdownOption}
                                id="swiftIfscCode"
                                iconClassName="dropdownIcon"
                                name="swiftIfscCode"
                                setValue={item?.swiftIfscCode || ""}
                                getvalue={setDropdownData}
                                index={item.id}
                                onChangeValue={handleChangeBankInfo}
                                // disabled={getDisabledStatus}
                              />
                            </Col>
                            <Row>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding d-flex"
                              >
                                {/* <FileUploadComponent
                                  id="bankCompanyletterhead"
                                  name="bankCompanyletterhead"
                                  // label="Company letterhead"
                                  label={
                                    <>
                                      <i className="bi bi-file-earmark-richtext labelIcon"></i>
                                      Company Letterhead
                                    </>
                                  }
                                  allowedTypes={[
                                    "image/png",
                                    "image/jpeg",
                                    "application/pdf",
                                  ]}
                                  multiple={true} // Change to false for single file selection
                                  required={true}
                                  onSuccessUpload={(data) =>
                                    onSuccessUploadBankDocumentType(data, index)
                                  }
                                  value={item?.bankCompanyletterhead || ""}
                                /> */}

                                <div className="d-flex align-items-center pe-2">
                                  {(item?.bankCompanyletterhead && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(
                                          item?.bankCompanyletterhead,
                                        )
                                      }
                                    />
                                  )) ||
                                    "--"}
                                </div>
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding d-flex"
                              >
                                {/* <FileUploadComponent
                                  id="bankConfirmationLetter"
                                  name="bankConfirmationLetter"
                                  // label="Confirmation letter"
                                  label={
                                    <>
                                      <i className="bi bi-file-earmark-check labelIcon"></i>
                                      Confirmation Letter
                                    </>
                                  }
                                  allowedTypes={[
                                    "image/png",
                                    "image/jpeg",
                                    "application/pdf",
                                  ]}
                                  multiple={true} // Change to false for single file selection
                                  required={true}
                                  onSuccessUpload={(data) =>
                                    onSuccessUploadBankDocumentType(data, index)
                                  }
                                  value={item?.bankConfirmationLetter || ""}
                                /> */}

                                <div className="d-flex align-items-center pe-2">
                                  {(item?.bankConfirmationLetter && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(
                                          item?.bankConfirmationLetter,
                                        )
                                      }
                                    />
                                  )) ||
                                    "--"}
                                </div>
                              </Col>
                            </Row>
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="commTopButtonRightLeftPadding"
                            >
                              <hr />
                            </Col>
                          </Row>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Company Profile */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible9
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility9}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CP</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Company Profile </span>
                      <span className="subHeaderTitle">
                        Company Profile Details
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible9 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Employee Name"
                          label={
                            <>
                              <i className="bi bi-person labelIcon"></i>
                              Company Name
                            </>
                          }
                          name="companyName"
                          placeholder=""
                          value={formInputs.companyName || ""}
                          onChange={onInputChange}
                          required={true}
                          error={validation.companyName}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          type="date"
                          label="Joining Date"
                          name="joiningDate"
                          id="joiningDate"
                          value={formInputs?.joiningDate}
                          onChange={handleInputChange}
                          min={2024}
                          disabled={!isEditMode}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Salary */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible9
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility9}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">S</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">
                        Salary Breakup Calculator
                      </span>
                      <span className="subHeaderTitle">
                        Salary Breakup Calculator
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible9 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      {/* <SalaryBreakupCalculator
                        salaryAmt={formInputs?.salaryAmt}
                        employeeName={formInputs?.employeeName}
                        designation={formInputs?.designation}
                        disabled={!isEditMode}
                        onChange={(updatedSalary) => {
                          if (!isEditMode) return;

                          setFormInputs((prev) => ({
                            ...prev,
                            salaryAmt: updatedSalary,
                          }));
                        }}
                      /> */}
                      {/* <SalaryBreakupCalculator
                        salaryAmt={
                          selectedSalaryRevision
                            ? formInputs?.salaryAmt?.[
                                `reviseSalary${selectedSalaryRevision}`
                              ] || {}
                            : formInputs?.salaryAmt
                        }
                        employeeName={formInputs?.employeeName}
                        designation={formInputs?.designation}
                        disabled={!isEditMode || !selectedSalaryRevision}
                        onChange={(updatedSalary) => {
                          if (!isEditMode || !selectedSalaryRevision) return;

                          const revisionKey = `reviseSalary${selectedSalaryRevision}`;

                          setFormInputs((prev) => ({
                            ...prev,
                            salaryAmt: {
                              ...(prev.salaryAmt || {}),
                              [revisionKey]: updatedSalary,
                            },
                          }));
                        }}
                      /> */}
                      <SalaryBreakupCalculator
                        salaryAmt={currentSalaryAmt}
                        employeeName={formInputs?.employeeName}
                        designation={formInputs?.designation}
                        disabled={!isEditMode || !selectedSalaryRevision}
                        onChange={handleSalaryChange}
                      />
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {getHrDoc.length > 0 && (
              <>
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible3
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility3}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">D</span>
                        </Col>
                        <Col xs={12} md={8} lg={8}>
                          <span className="headerTitle">Documents</span>
                          <span className="subHeaderTitle">
                            View of Documents List{" "}
                          </span>
                        </Col>

                        {/* <Col xs={2} md={1} lg={1} className="">
                                      <POCollabrationCommonFillter />
                                    </Col> */}
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible3 ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              columns={hrDataColumns}
                              data={getHrDoc}
                              // progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default EmployeeDetails;
